import Modal, { ModalProps, OnSwipeCompleteParams } from "./modal";
import {
    AnimationEvent,
    Animations,
    SupportedAnimation,
    Orientation,
    Direction,
    PresentationStyle,
    OnOrientationChange,
} from "./types";

export type {
    AnimationEvent,
    Animations,
    SupportedAnimation,
    Orientation,
    Direction,
    PresentationStyle,
    OnOrientationChange,

    ModalProps,
    OnSwipeCompleteParams,
};

export {
    Modal,
};
